import { createFileRoute } from '@tanstack/react-router';
import { SecondFactorPage } from '../components/pages/SettingsPage/SecondFactorPage';

export const Route = createFileRoute('/account/settings_/2fa')({
  component: SecondFactorPage,
});
